import React, { Fragment } from "react";
import styled from "styled-components";

import SocialButton from "../../UI/SocialButton/SocialButton";
import { isCordovaApp } from "../../../utils/cordovaUtils";
import VerseActionPopover from "./VerseActionPopover";

const PopoverPositioner = styled.div<{
  top: string | number;
  left: string | number;
}>`
  position: absolute;
  z-index: 1100;
  transform: ${({ top, left }) => `translate(${left || 0}px, ${top || 0}px)`};
  transition: transform 75ms ease-out;
`;

const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
`;

const ActionSet = styled.div`
  text-align: center;
  display: flex;
  align-items: center;
  padding: 0 4px !important;

  &:last-child {
    border-left: 1px solid #666;
  }

  &:first-child {
    border-left: none;
  }
`;

interface PopoverProps {
  position: {
    top: string | number;
    left: string | number;
  };
  bibleId: string;
  chapterRef: string;
  currentChapterRef: string | void;
  selectedVerseOrgIds?: string[];
}

const Popover = ({
  position: { top, left },
  bibleId,
  chapterRef,
  currentChapterRef,
  selectedVerseOrgIds = []
}: PopoverProps) => {
  // if the current viewed chapter is different than the chapter when
  // the pop over was clicked, do not render the Popover
  // or if there isn't a selected verse(s)
  if (
    !chapterRef ||
    currentChapterRef !== chapterRef ||
    selectedVerseOrgIds.length === 0
  ) {
    return null;
  }

  return (
    <PopoverPositioner top={top} left={left}>
      <VerseActionPopover
        bibleId={bibleId}
        selectedVerseOrgIds={selectedVerseOrgIds}
        render={({ url, message }) => (
          <ActionsContainer>
            <ActionSet key="social-wrap">
              {!isCordovaApp && (
                <Fragment>
                  <SocialButton
                    key="twitter"
                    socialType="twitter"
                    message={message}
                    url={url}
                  />
                  <SocialButton
                    key="facebook"
                    socialType="facebook"
                    message={message}
                    url={url}
                  />
                </Fragment>
              )}
              {isCordovaApp && (
                <SocialButton
                  key="cordova"
                  socialType="cordova"
                  message={message}
                  url={url}
                />
              )}
              <SocialButton
                key="link-copy"
                socialType="link-copy"
                url={url}
                message={message}
              />
              <SocialButton
                key="verse-copy"
                socialType="verse-copy"
                message={message}
                url={url}
              />
            </ActionSet>
          </ActionsContainer>
        )}
      />
    </PopoverPositioner>
  );
};

export default Popover;
